import { Component, OnInit } from '@angular/core';
import { BlogService } from '../../services/blog.service';
import { iHttpPaginatedResponse } from '../../interfaces/iHttpPaginatedResponse';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {
  public paginatedData: iHttpPaginatedResponse;
  public loadingArticles = true;
  public breadcrumbLinks=[];
  public thisPage:string='Blog';
  public perPage=9;

  constructor(private blogService:BlogService) { }

  ngOnInit() {
    this.getPosts(1);
  }

  public getPosts(page){
    this.blogService.getAll(page, this.perPage).subscribe(paginatedData=>{
      this.paginatedData = paginatedData;
      this.loadingArticles = false;
    });
  }

  public pageChanged(page){
    this.getPosts(page);
  }
}
